import React, { useEffect, useRef } from "react";
import { updateWebsocketData } from "../../services/websocket-data";
import { useDispatch } from "react-redux";
import { setReadyWebsocketData } from "../../redux/actions/shared-actions";

/**
 * Provides connection to the server via websocket. Tries to reconnect every 5000 miliseconds if the connection breaks.
 * @component
 * @category Components
 * @subcategory Websocket-connection
 */

const WebSocketConnection = () => {
  const dispatch = useDispatch();
  const ws = useRef(null);
  const wsConnect = (ws) => {
    ws.current = new WebSocket(window.__CONFIG__.WEBSOCKET_URL);
    ws.current.onopen = () => console.log("Connected to the server.");
    ws.current.onmessage = (e) => {
      const data = JSON.parse(e.data);
      updateWebsocketData(data);
    };
    ws.current.onclose = () => {
      console.log("Connection to server failed.");
      dispatch(setReadyWebsocketData(false));
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    };
  };

  useEffect(() => {
    wsConnect(ws);
    const wsCurrent = ws.current;
    return () => {
      wsCurrent.close();
    };
  });

  return <></>;
};

export default React.memo(WebSocketConnection);
